export default __webpack_public_path__ + "static/media/Practical.b6899fc1.jpg";